import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lottie from "lottie-react";

gsap.registerPlugin(ScrollTrigger);

const ServicePage = () => {
  const servicesRef = useRef(null);

  // useEffect(() => {
  //     const ctx = gsap.context(() => {
  //         gsap.fromTo(
  //             '.service-item',
  //             { y: 50, opacity: 0 },
  //             {
  //                 y: 0,
  //                 opacity: 1,
  //                 duration: 0.8,
  //                 stagger: 0.5,
  //                 scrollTrigger: {
  //                     trigger: servicesRef.current,
  //                     start: 'top 80%',
  //                     toggleActions: 'play none none reverse',
  //                 },
  //             }
  //         );
  //     }, servicesRef);

  //     return () => ctx.revert();
  // }, []);

  const services = [
    {
      name: "Hair Reduction",
      animation: require("../assets/Lootie/hair_reduction.json"),
    },
    {
      name: "Pigment Removal",
      animation: require("../assets/Lootie/pigment_removal.json"),
    },
    {
      name: "Skin Tightening",
      animation: require("../assets/Lootie/skin_tightening.json"),
    },
    {
      name: "Skin Lifting",
      animation: require("../assets/Lootie/skin_lifting.json"),
    },
    {
      name: "Analyzers",
      animation: require("../assets/Lootie/analyzers.json"),
    },
    {
      name: "Hydra Facial",
      animation: require("../assets/Lootie/hydra_facial.json"),
    },
    {
      name: "Body Sculpting",
      animation: require("../assets/Lootie/body_sculpting.json"),
    },
    {
      name: "Hair Regrowth",
      animation: require("../assets/Lootie/hair_regrowth.json"),
    },
  ];

  return (
    <>
      <section ref={servicesRef} className="py-16 my-16 m-3 lg:hidden">
        <div className="container mx-auto">
          <h2 className=" text-colorPrimary font-bold text-center mb-8 text-3xl ">
            SERVICES OVERVIEW
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {services.map((service, index) => (
              <div
                key={index}
                className="service-item bg-white border-2 border-colorPrimary m-2 rounded-2xl shadow-md text-center p-4"
              >
                <div className="flex justify-center items-center w-32 h-28 mx-auto mb-4">
                  <Lottie
                    alignItems="center"
                    animationData={service.animation}
                  />
                </div>
                <p>{service.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicePage;
